export default "__VITE_ASSET__DcQDECS0__"